export default __webpack_public_path__ + "static/media/Six.dec936bd.jpg";